<template>
    <ButtonComp
        button-type="Secondary"
        icon="fa-tower-control"
        @click="openModal"
        :class="{
            'bg-success bg-opacity-75 text-white': IsRunning,
            'focus-ring focus-ring-success': hasNewCompleted,
        }"
    >
    </ButtonComp>

    <ModalComp
        title="eventinfo.racecontrol"
        titleIcon="fa-tower-control"
        size="xxl"
        :keep-alive="true"
        ref="modal"
        @closed="isVisible = false"
    >
        <template #content>
            <div class="pb-3 vh-75">
                <RaceControl
                    @category-completed="onCategoryCompleted"
                    v-if="isInitialized"
                />
            </div>
        </template>

        <template #footer>
            <ButtonComp
                button-type="Close"
                @click="modal?.hide()"
                >{{ $tm('button.close') }}</ButtonComp
            >
        </template>
    </ModalComp>
</template>

<script setup lang="ts">
import { ModalComp, ButtonComp } from '@/components';
import { watch, ref, type ComponentInstance } from 'vue';
import { useEventStoreRef, useRaceContestantTimesSubscription, useRaceContestantTimeStore, useRaceControlStoreRef } from '@/stores';
import type { RaceControlItem } from '@/objects/RaceControlItem';
import RaceControl from '../views/RaceControl/RaceControl.vue';

const modal = ref<ComponentInstance<typeof ModalComp> | null>(null);

// Global property to see if the RaceControl is running
const { IsRunning } = useRaceControlStoreRef();

const { eventID } = useEventStoreRef();

// After the button is pressed the first time it is initialized. That means it is active and will update in the background
// We mark it with a green background.
const isInitialized = ref(false);

// If the modal is visible or not.
// We dont care about updating the state on the button if it is visible
const isVisible = ref(false);

// If a new category has been completed while the modal is not visible
const hasNewCompleted = ref(false);

/**
 * We open the modal and start handling the active times
 */
const openModal = () => {
    isInitialized.value = true;
    modal?.value?.show();
    isVisible.value = true;
    hasNewCompleted.value = false;
};

/**
 * Callback whenever a new category is completed. i.e has all the contestants finished
 */
const onCategoryCompleted = (item: RaceControlItem) => {
    if (!isVisible.value) {
        hasNewCompleted.value = true;
    }
    // console.log('Category completed', item);
};

// Watch the active times scroll
useRaceContestantTimesSubscription(
    (times) => {
        // console.log('RaceControl active times update', times);
    },
    {
        triggerForExistingTimes: false,
        timeTypes: ['Time'],
    },
);

/**
 * Whenever the event changes, we reset the state of the component.
 */
watch(eventID, () => {
    isInitialized.value = false;
    modal?.value?.destroy();
});
</script>
